export const ONBOARDING_SLUGS = ["brand-persona", "avatar-builder"];

export function isOnboardingAgent(slug) {
  return ONBOARDING_SLUGS.includes(slug);
}

export function contentAgents(list) {
  return (list || []).filter((a) => !isOnboardingAgent(a.slug));
}
